import {
  sharedOptions,
  gridOptions,
  stackedGridOptions,
  data,
  dataMixed,
  options,
  dataBubble,
  dataDoughnut,
  height } from './chart';

export default [{
  type: 'bar',
  title: 'Visits',
  subtitle: '+458,90',
  data: data,
  height: height,
  options: {
    ...sharedOptions,
    ...gridOptions,
    ...stackedGridOptions
  }
}, {
  type: 'bar',
  title: 'Enquiries',
  subtitle: '-46,68',
  data: dataMixed,
  height: height,
  options: {
    ...sharedOptions,
    ...gridOptions,
    ...options
  }
},/* {
  type: 'bubble',
  title: 'Sample Report',
  subtitle: '+2,50%',
  data: dataBubble,
  height: height,
  options: {
    ...sharedOptions
  }
},*/ {
  type: 'doughnut',
  title: 'Status',
  subtitle: '+2,50%',
  data: dataDoughnut,
  height: height,
  options: {
    ...sharedOptions
  }
}]


// WEBPACK FOOTER //
// ./src/utils/mock/dashboard.js